import React from 'react';

const SvgNi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="NI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="NI_svg__b" fill="#fff">
        <use xlinkHref="#NI_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#1A78D6"
        mask="url(#NI_svg__b)"
        d="M0 0h28v6.667H0zM0 13.333h28V20H0z"
      />
      <circle
        stroke="#DBCD92"
        strokeWidth={0.667}
        mask="url(#NI_svg__b)"
        cx={14}
        cy={10}
        r={2.333}
      />
      <path
        fill="#9CDDEE"
        mask="url(#NI_svg__b)"
        d="M14 8.667l1.333 2.666h-2.666z"
      />
    </g>
  </svg>
);

export default SvgNi;
